import { useCallback, useState } from 'react';
import { useModalController, type UseModalControllerPayload } from './useModalController';

export interface InsufficientItem {
    available: number;
    id: string;
    delivery_chunk_id?: number;
}

export interface UseOutdatedStockModalControllerPayload extends UseModalControllerPayload {
    insufficientItems?: InsufficientItem[];
    setInsufficientItems: (items?: InsufficientItem[]) => void;
}

export function useOutdatedStockModalController(): UseOutdatedStockModalControllerPayload {
    const modalProps = useModalController();
    const [insufficientItems, setInsufficientItems] = useState<InsufficientItem[] | undefined>(undefined);

    const setInsufficientItemsCallback = useCallback(
        (items?: InsufficientItem[]) => setInsufficientItems(items),
        [setInsufficientItems]
    );

    return { ...modalProps, setInsufficientItems: setInsufficientItemsCallback, insufficientItems };
}
